<section class="login-page">
  <aside class="login-hero" aria-label="Portal highlight panel">
    <div class="login-hero__overlay"></div>
    <video
      class="login-hero__media"
      src="assets/videos/0_Solar_Panels_Wind_Turbines_1080x1920.mp4"
      autoplay
      muted
      loop
      playsinline
      preload="metadata"
      aria-hidden="true"
    ></video>

    <div class="login-hero__content">
      <div class="login-hero__brand">
        <span class="brand-mark">MH</span>
        <div class="brand-copy">
          <span class="brand-title">MH-RE DSM Portal</span>
          <span class="brand-subtitle">Maharashtra State Load Despatch Centre</span>
        </div>
      </div>

      <div class="hero-copy">
        <span class="hero-kicker"><i></i> Live renewable energy operations</span>
        <h1>Powering a smarter, <span>cleaner grid.</span></h1>
        <p>
          Monitor schedules, generation, deviations, approvals, and compliance from one
          secure command centre built for Maharashtra's renewable energy ecosystem.
        </p>
      </div>

      <div class="hero-metrics" aria-label="Platform highlights">
        <div><strong>96</strong><span>DSM blocks daily</span></div>
        <div><strong>24×7</strong><span>Grid visibility</span></div>
        <div><strong>1</strong><span>Unified platform</span></div>
      </div>
    </div>

    <div class="grid-status" aria-label="Grid status">
      <span class="grid-status__icon">↗</span>
      <div><small>Grid status</small><strong><i></i> Operations normal</strong></div>
      <b>LIVE</b>
    </div>
  </aside>

  <div class="login-panel">
    <section class="auth-card" aria-label="Sign in form">
      <div class="auth-card__glow" aria-hidden="true"></div>
      <div class="auth-heading">
        <span class="auth-eyebrow">Secure portal access</span>
        <h2>Welcome back</h2>
        <p>Sign in to continue to your operations workspace.</p>
      </div>

      <div class="social-grid">
        <button class="social-button" type="button">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path fill="#4285f4" d="M21.6 12.2c0-.7-.1-1.4-.2-2H12v3.9h5.4a4.6 4.6 0 0 1-2 3v2.5h3.3c1.9-1.8 2.9-4.4 2.9-7.4Z"/><path fill="#34a853" d="M12 22c2.7 0 5-.9 6.7-2.4l-3.3-2.5c-.9.6-2.1 1-3.4 1a5.9 5.9 0 0 1-5.5-4.1H3.1v2.6A10 10 0 0 0 12 22Z"/><path fill="#fbbc05" d="M6.5 14a6 6 0 0 1 0-3.9V7.5H3.1a10 10 0 0 0 0 9.1L6.5 14Z"/><path fill="#ea4335" d="M12 6a5.4 5.4 0 0 1 3.8 1.5l2.9-2.8A9.7 9.7 0 0 0 12 2a10 10 0 0 0-8.9 5.5l3.4 2.6A5.9 5.9 0 0 1 12 6Z"/></svg>
          Continue with Google
        </button>
        <button class="social-button" type="button">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path fill="#1877f2" d="M22 12a10 10 0 1 0-11.6 9.9v-7H7.9V12h2.5V9.8c0-2.5 1.5-3.8 3.7-3.8 1.1 0 2.2.2 2.2.2v2.4h-1.2c-1.2 0-1.6.8-1.6 1.5V12h2.7l-.4 2.9h-2.3v7A10 10 0 0 0 22 12Z"/></svg>
          Continue with Facebook
        </button>
      </div>

      <div class="divider"><span>or use email</span></div>

      <form class="login-form" [formGroup]="form" (ngSubmit)="submit()">
        <label>
          <span>Email address</span>
          <div class="input-shell">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 6h16v12H4zM4 7l8 6 8-6"/></svg>
            <input type="email" formControlName="email" placeholder="name@example.com" autocomplete="email">
          </div>
        </label>

        <label>
          <span>Password</span>
          <div class="input-shell">
            <svg viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="10" width="14" height="10" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/></svg>
            <input type="password" formControlName="password" placeholder="Enter your password" autocomplete="current-password">
          </div>
        </label>

        <div class="form-options">
          <label class="remember">
            <input type="checkbox">
            <span>Remember me</span>
          </label>
          <a routerLink="/forgot-password">Forgot Password?</a>
        </div>

        <button class="submit-button" type="submit" [disabled]="form.invalid">
          <span>Sign in securely</span><b>→</b>
        </button>

        @if (message) {
          <p class="auth-message">{{ message }}</p>
        }
      </form>

      <p class="create-account">New to the RE-DSM portal? <a class="create-link" routerLink="/register">Create an account</a></p>
      <div class="security-note"><span>✓</span> Protected by encrypted, role-based access</div>
    </section>
  </div>
</section>
